import script from "./Nav-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nav-bar.vue?vue&type=script&lang=ts&setup=true"

import "./Nav-bar.vue?vue&type=style&index=0&id=4ca04536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca04536"]])

export default __exports__